/* eslint-disable */
import react, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ExcelColor_Icon from "../icons/ExcelColor_Icon";
import PdfColor_Icon from "../icons/PdfColor_Icon";
import ModalTravels from "./ModalTravels";
import Car_Icon from "../icons/Car_Icon";
export default function TableDrivers({ Drivers }) {
  const [openTravels, setOpenTravels] = useState(false);
  const [TravelsforDriver, setTravelsforDriver] = useState([]);
  const openShowTravelsModal = () => setOpenTravels(true);
  const closeShowTravels = () => setOpenTravels(false);
  const columns = [
    {
      name: "Id",
      selector: (row) => row.driver_id,
      sortable: true,
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Car_Icon color="#004990" />
          <strong>{row.driver_id?.substring(0, 6)}</strong>
        </div>
      ),
    },
    {
      name: "Nombre completo",
      selector: (row) =>
        row.driver_info?.name + " " + row.driver_info?.last_name,
      sortable: true,
    },
    {
      name: "Correo electrónico",
      selector: (row) => row.driver_info?.email,
      sortable: true,
    },

    {
      name: "Número telefónico",
      selector: (row) => row.driver_info?.phone,
      sortable: true,
    },
    {
      name: "Estatus",
      selector: (row) => row.driver_info?.status,
      sortable: true,
    },
    {
      name: "RFC",
      selector: (row) => row.driver_info?.rfc,
      sortable: true,
    },
    {
      name: "Viajes finalizados",
      selector: (row) => row.travel_matches.length,
      sortable: true,
      cell: (row) => <strong>{row.travel_matches.length}</strong>,
    },
  ];

  const tableCustomStyles = {
    table: {
      style: {
        zIndex: -0,
        height: "50vh",
      },
    },
    headCells: {
      style: {
        color: "#202124",
        fontSize: "14px",
      },
    },
    rows: {
      highlightOnHoverStyle: {
        backgroundColor: "rgba(0, 73, 144, 0.2)",
        borderBottomColor: "#FFFFFF",
        borderRadius: "10px",
        outline: "1px solid #FFFFFF",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "50px",
      }}
    >
      <div
        style={{
          width: "90%",
          borderRadius: "10px",
          backgroundColor: "white",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          padding: "10px",
        }}
      >
        <DataTable
          title="Conductores con viajes finalizados (GLOBAL)"
          fixedHeader
          columns={columns}
          data={Drivers}
          pagination
          customStyles={tableCustomStyles}
          highlightOnHover
          pointerOnHover
          paginationComponentOptions={paginationComponentOptions}
          /*           actions={[LoginGoogle, LogoutGoogle]} */
          onRowClicked={(row) => {
            setTravelsforDriver(row);
            openShowTravelsModal();
          }}
        />
      </div>
      {openTravels && (
        <ModalTravels
          ObjectDriver={TravelsforDriver}
          closeTravels={closeShowTravels}
          openTravels={openTravels}
        />
      )}
    </div>
  );
}
